<template>
  <div class="myhome-header__button">
    <h3 class="dea-heading--medium__m">
      Cerchi un corso di formazione<br />
      adatto a te?
    </h3>
    <Buttons
      class="dea-button dea-button--large dea-button--iconRight"
      :href="$root.config.formazione_url"
      icon="go-to"
      :data-test="`courses-trigger-${role}`"
      type="a"
      target="_blank"
    >
      Esplora l'offerta
    </Buttons>
  </div>
</template>

<script>
import Buttons from "deascuola-storybook/src/components/elements/Buttons";

export default {
  name: "ButtonCourses",
  components: { Buttons },
  props: {
    role: {
      type: String,
      default: "ROLE_TEACHER",
    },
  },
};
</script>
